import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import NumberField from "src/components/NumberField";
import { getMileage, getRate } from "../mileage";
import { getMileageDescription, Dash } from "./utils";
import { Row } from "./Row";
import { DateInput } from "./DateInput";
import type { FormProps } from "./types";

export function MileageForm({
  errors,
  values,
  loading,
  handleChange,
  setValues,
}: FormProps) {
  const isUpdate = !!values.id;
  const description = getMileageDescription(values.description);
  const [mileage, setMileage] = useState(
    getMileage(values.date, values.amount)
  );
  const handleDescriptionChange = (description: string, mileage: number) => {
    setValues((v) => ({
      ...v,
      description: `${description} ${Dash} ${mileage} miles`,
    }));
  };
  const handleAmountChange = (mileage: number, date?: Date) => {
    if (!date) return;
    const rate = getRate(date);
    if (!rate) return;

    setValues((v) => ({
      ...v,
      amount: rate * mileage,
    }));
  };

  return (
    <>
      <Row>
        <FormControl fullWidth variant="outlined" margin="dense">
          <InputLabel variant="outlined">Drove</InputLabel>
          <NumberField
            Component={Input}
            fullWidth
            disabled={loading}
            value={mileage || ""}
            onChange={(e) => {
              const value = e.target.value
                ? parseFloat(`${e.target.value}`) || 0
                : 0;
              setMileage(value);
              handleDescriptionChange(description, e.target.value || 0);
              handleAmountChange(value, values.date);
            }}
            endAdornment={<InputAdornment position="end">miles</InputAdornment>}
            type="number"
            label="Drove"
            fixed={2}
          />
        </FormControl>
      </Row>
      <Row>
        <DateInput
          error={!!errors.date}
          helperText={errors.date}
          value={values.date}
          loading={loading}
          onChange={(e) => {
            let date = e.target.value;
            if (!isUpdate && date?.getTime()) {
              date.setUTCHours(12, 0, 0, 0);
            }
            setValues({ ...values, date });
            handleAmountChange(mileage, date);
          }}
        />
      </Row>
      <Row text="A note to remind you what was purchased.">
        <TextField
          error={errors.description ? true : false}
          helperText={errors.description}
          fullWidth
          variant="outlined"
          margin="dense"
          label="Description"
          value={description}
          disabled={loading}
          onChange={(e) => {
            handleDescriptionChange(e.target.value, mileage);
          }}
        />
      </Row>
    </>
  );
}
